'use es6';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import WithBusinessUnitsDataFetching from 'ui-business-units-lib/utils/WithBusinessUnitsDataFetching';
import { selectHasBusinessUnitsAccess } from 'dashboard-lib/public/userInfo/scopes';
import RestoreReportsTable from './RestoreReportsTable';
import RestoreReportsListHeader from './RestoreReportsListHeader';
import AsyncRestoreReportsListSubHeader from './AsyncRestoreReportsListSubHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RestoreReportsListingPage = ({
  buOptions,
  isLoading: isBusinessUnitsLoading
}) => /*#__PURE__*/_jsxs(ListingPage, {
  pageLayout: "full-width",
  headerComponent: /*#__PURE__*/_jsx(RestoreReportsListHeader, {}),
  children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(AsyncRestoreReportsListSubHeader, {
    buOptions: buOptions
  }), /*#__PURE__*/_jsx(RestoreReportsTable, {
    buOptions: buOptions,
    isBusinessUnitsLoading: isBusinessUnitsLoading
  })]
});
RestoreReportsListingPage.propTypes = {
  buOptions: PropTypes.array,
  isLoading: PropTypes.bool
};
const ReportsListingPageWithBusinessUnits = WithBusinessUnitsDataFetching(RestoreReportsListingPage);
const RestoreReportsListingPageWithDataFetching = props => {
  const hasBusinessUnitsAccess = useSelector(selectHasBusinessUnitsAccess);
  return hasBusinessUnitsAccess ? /*#__PURE__*/_jsx(ReportsListingPageWithBusinessUnits, Object.assign({}, props)) : /*#__PURE__*/_jsx(RestoreReportsListingPage, Object.assign({}, props));
};
export default RestoreReportsListingPageWithDataFetching;